export default "/apps/maps/img/fa-regular-400.svg";